import React,{ useContext, useState } from 'react'
import { DRIVELINK } from '../config';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import PageHeader from '../components/PageHeader';
import useDocumentTitle from '../components/useDocumentTitle';
import SuccessAlert from '../components/SuccessAlert';
import Loading from '../components/Loading';
import { capitalize } from '../components/ModalSignUp';
import ErrorWrapper from '../components/ErrorWrapper';

import MyOpenDataContext from '../context/OpenDataContext';

const style = {
    formInput: "block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none  focus:outline-none focus:ring-0 focus:border-teal-500 peer",
    formLabel: "peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-2 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-teal-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
}

const OpenData = () => {
    const { createRequest, error, setError, loading } = useContext(MyOpenDataContext);
    const[successAlert, setSuccessAlert] = useState(null);
    const [ok, setOk] = useState(false)

    const schema = yup.object().shape({
        userRequestName: yup.string().required("El nombre es requerido").max(120, "El nombre no puede tener mas de 120 caracteres").min(5, "El nombre no puede tener menos de 5 caracteres").trim().transform((currentValue) => capitalize(currentValue)),
        userRequestEmail: yup.string().email("El correo es inválido").required("El correo es requerido").max(120, "El correo no puede tener mas de 120 caracteres").trim(),
        userRequestPhone: yup.string().required("El numero de telefono es requerido ").min(8, "El numero de telefono no puede tener menos de 8 caracteres").max(15, "El numero de telefono no puede tener mas de 15 caracteres").matches(/^\d+$/, "El numero de telefono es inválido"),
        userRequestDocument: yup.string().required("El numero de documento es requerido").min(6, "El numero de documento es invalido").max(15, "El numero de documento no puede tener mas de 15 caracteres").matches(/^\d+$/, "El numero de documento es inválido"),
        userRequestAddress: yup.string().required("La dirección es requerida").max(120, "La dirección no puede tener mas de 120 caracteres").min(5, "La dirección no puede tener menos de 5 caracteres").trim(),
        privacyTerms: yup.boolean().oneOf([true], "Debes aceptar nuestros términos y condiciones")
    })

    const onSubmit = async (data) => {
        setOk(false)
        setError({ "error": false, "message": "" })
        const res = await createRequest(data);
        if (res.error) {
            setError({ "error": true, "message": res.response })
        } else {
            setOk(true)
            reset()
            setSuccessAlert(res.response)
            setTimeout(() => {
                window.open(DRIVELINK, "_blank")
                setSuccessAlert(null)
            }, 2000);
        }
        setTimeout(() => {
            setError({ "error": false, "message": "" })
            setOk(false)
        }, 10000);
    }

    useDocumentTitle("Datos Abiertos");

    const { handleSubmit, register, reset, formState: { errors } } = useForm({
        resolver: yupResolver(schema)
    });
    return (
        <div>
            <PageHeader tittle="DATOS ABIERTOS" />
            <SuccessAlert isVisible={successAlert} />
            <div className="flex flex-col items-center mx-auto my-8 p-8 rounded-xl bg-white w-[95%] sm:w-[90%] 2lg:w-[85%] shadow-xl">
                <h2 className="font-light text-center text-xl wow animate__animated animate__fadeInUp animate__slow">Para acceder a los datos abiertos de la Dirección de Gestión Catastral de Neiva, por favor diligencie el siguiente formulario.</h2>
                <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col w-full mt-8 items-center justify-center">
                    <div className="grid grid-cols-1 2md:grid-cols-2 place-items-center w-full">
                        <div className="relative z-0 mb-6 w-4/5 2md:w-2/3 group">
                            <input type="text" {...register("userRequestName")} className={style.formInput} placeholder=" " />
                            <label className={style.formLabel}>Nombre completo*</label>
                            <ErrorWrapper error={errors.userRequestName?.message} />
                        </div>
                        <div className="relative z-0 mb-6 w-4/5 2md:w-2/3 group">
                            <input type="text" {...register("userRequestEmail")} className={style.formInput} placeholder=" " />
                            <label className={style.formLabel}>Correo electronico*</label>
                            <ErrorWrapper error={errors.userRequestEmail?.message} />
                        </div>
                        <div className="relative z-0 mb-6 w-4/5 2md:w-2/3 group">
                            <input type="number" {...register("userRequestPhone")} className={style.formInput} placeholder=" " />
                            <label className={style.formLabel}>Teléfono*</label>
                            <ErrorWrapper error={errors.userRequestPhone?.message} />
                        </div>
                        <div className="relative z-0 mb-6 w-4/5 2md:w-2/3 group">
                            <input type="number" {...register("userRequestDocument")} className={style.formInput} placeholder=" " />
                            <label className={style.formLabel}>Documento de identidad*</label>
                            <ErrorWrapper error={errors.userRequestDocument?.message} />
                        </div>
                        <div className="relative z-0 mb-6 w-4/5 2md:w-2/3 group">
                            <input type="text" {...register("userRequestAddress")} className={style.formInput} placeholder=" " />
                            <label className={style.formLabel}>Dirección*</label>
                            <ErrorWrapper error={errors.userRequestAddress?.message} />
                        </div>
                        <div className="relative z-0 mb-6 w-4/5 2md:w-2/3 group">
                            <input type="checkbox" {...register("privacyTerms")} className="mr-2" id='privacyTerms'/>
                            <label htmlFor="privacyTerms" className="text-sm text-gray-700">Acepto la <a target="_blank" href="https://www.alcaldianeiva.gov.co/Paginas/Politicas-de-Privacidad-y-Condiciones-de-Uso.aspx" className="text-green-400 hover:text-blue-800">Politica de Privacidad, Tratamiento de datos personales y Condiciones de uso </a>de la Alcaldía de Neiva.</label>
                            <ErrorWrapper error={errors.privacyTerms?.message} />
                        </div>
                    </div>
                    {error.error && <ErrorWrapper error={error.message} />}
                    {ok && <p className="text-sm text-gray-700">¡Gracias por diligenciar el formulario! Si no has sido redireccionado, haz click <a target="_blank" href="https://www.alcaldianeiva.gov.co/Paginas/Politicas-de-Privacidad-y-Condiciones-de-Uso.aspx" className="text-green-400 hover:text-blue-800">aquí!</a></p>}
                    {loading ? <Loading isLoading={loading} /> : <button className="w-[45%] md:w-[30%] lg:w-[20%] mt-4 py-3 px-5 text-md text-center border-2 border-pageHeader hover:bg-pageHeader hover:text-white transition-all duration-500 rounded-xl hover:rounded-2xl p-2">Acceder</button>}
                </form>
            </div>
        </div>
    );
}
 
export default OpenData;